var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobalProvide5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 38,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "global-provide-5_svg__a",
  width: 40,
  height: 38,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39.333.5H.667v37h38.666z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#global-provide-5_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeWidth: 2,
  d: "M22.153 19.61c3.385 3.355 8.872 3.355 12.257 0a8.535 8.535 0 0 0 0-12.147c-3.385-3.354-8.872-3.354-12.257 0a8.535 8.535 0 0 0 0 12.147Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#408BFC",
  d: "M31.524 16.923c.291.289.77.291 1.017-.035a5.243 5.243 0 0 0 .526-5.511c-.182-.367-.652-.453-.993-.224-.34.23-.422.689-.26 1.065a3.78 3.78 0 0 1-.344 3.61c-.23.34-.238.806.054 1.095"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeWidth: 2,
  d: "M18.092 27.157a2.475 2.475 0 0 0 0-3.521 2.53 2.53 0 0 0-3.554 0l-7.615 7.547a2.475 2.475 0 0 0 0 3.522 2.53 2.53 0 0 0 3.554 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#408BFC",
  d: "m21.035 18.215 2.357 2.336-4.351 4.313-2.357-2.336z"
}))));
export default SvgGlobalProvide5;